<template>
  <div>
    <slot name="header"></slot>
    <slot name="hero"></slot>
    <slot name="breadcrumb"></slot>
    <div class="h-screen">
      <slot name="courses"></slot>
    </div>
    <slot name="footer"></slot>
    <slot name="default"></slot>

    <!-- <div class="membership-layout-container pb-16">
      <div class="flex text-xl font-bold mb-10">Instructor</div>

      <div class="flex items-center mb-6">
        <img
          src="https://assets.grooveapps.com/images/9d280130-6f1d-429a-8231-b7d77de8c3c4/1625653640_image_2021_05_13T05_32_47_833Z.png"
          alt="Avatar"
          class="h-20 w-20 object-cover rounded-full"
        />
        <div class="ml-5">
          <div class="text-base font-bold text-blue-light mb-1">
            Thomas Frank
          </div>
          <div class="text-xs font-semibold text-grey-600">
            youtube author entrepreneur
          </div>
        </div>
      </div>
      <div class="text-xs text-grey-600">
        <p class="mb-5">
          It is a long established fact that a reader will be distracted by the
          readable content of a page when looking at its layout. by the readable
          <span class="text-dark font-bold">content</span> of a page when
          <span class="text-dark font-bold">looking</span>
        </p>
        <p class="mb-5">
          It is a long established fact that a reader will be distracted by the
          readable content of a page when looking at its layout.It is a long
          established fact that a reader will be
          <span class="text-dark font-bold">distracted by the</span> readable
          content of a page when looking at its layout.It is a long established
          fact that a reader will be distracted by the readable content of a
          page when looking at its layout.It is a long established fact that a
          <span class="text-dark font-bold">reader will be distracted</span> by
          the readable content of a page when looking at its layout.
        </p>
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  name: 'SubcategoryMarkup',
  data() {
    return {};
  },
};
</script>